import { dataTypes, Binding, Location } from '@adalo/constants'
import { BlurhashMetadataRemote } from 'types'

export type CellProps = {
  cell: CellData
}

export type TableValue = {
  filename: string
  size: string
  url: string
}

export type FileValue = {
  filename: string
  size: string
  url: string
}

export type ImageValue = {
  filename: string
  height: number
  metadata: BlurhashMetadataRemote
  size: number
  url: string
  width: number
}

export type FieldValue =
  | string
  | number
  | boolean
  | Location
  | FileValue
  | ImageValue

export type DataTypeKeys = typeof dataTypes[keyof typeof dataTypes]

export type CellData = {
  binding?: Binding
  type: DataTypeKeys
  label: string
  value: FieldValue
  fieldId: string
}

export type Field = {
  fieldId: string
  label: string
  type: DataTypeKeys
  binding: Binding
}

export type BindingDataItem = {
  id: number
} & {
  [key: string]: FieldValue
}

export type Dimensions = {
  width: number
  height: number
}

// TODO(dyego): could be moved to `@adalo/constants`
export const CIRCLE = 'circle'
export const SQUARE = 'square'
export const LANDSCAPE = 'landscape'
export const PORTRAIT = 'portrait'
